<template>
  <div>
    <Head />

    <div class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">重設密碼</li>
      </ol>
    </div>
    <div class="wrapper sign_up forget">
      <section class="main">
        <div class="container">
          <div class="box">
            <h2>重設密碼</h2>
            <div class="form-group">
              <label for="">統一編號</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入統一編號" v-model="TaxID" :disabled="pincodeCheck">
            </div>
            <div class="form-group">
              <label for="">電子郵件</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入電子郵件" v-model="Email" :disabled="pincodeCheck">
            </div>
            <div class="btn_box" v-if="!pincodeCheck">
              <button @click="getPinCode()">
                {{ pincodeTitle }}
              </button>
            </div>
            <div class="form-group" v-if="pincode">
              <label for="">驗證碼</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入驗證碼"
                v-model="pincode_input" @input="pincode_input_onInput" :disabled="pincodeCheck">
            </div>
            <div class="form-group" v-if="pincodeCheck">
              <label for="">請輸入新密碼</label>
              <input type="password" class="form-control" id="" aria-describedby="" placeholder="請輸入新密碼" v-model="Password">
            </div>
            <div class="form-group" v-if="pincodeCheck">
              <label for="">請再次輸入新密碼</label>
              <input type="password" class="form-control" id="" aria-describedby="" placeholder="請再次輸入新密碼" v-model="PasswordConfirm">
            </div>
            <div class="btn_box" v-if="pincodeCheck">
              <button @click="forget()">重設密碼</button>
            </div>
            <div class="forget">
              <router-link :to="{ name: 'LoginForUser' }">返回會員登入</router-link>
            </div>
          </div>
        </div>
      </section>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Forget",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      TaxID: "",
      Email: "",
      Password: "",
      PasswordConfirm: "",
      pincode_input: "",
      pincode: "",
      pincodeCheck: false,
      pincodeTitle: "發送驗證碼",
      pincodeTime: 0,
      pincode_TaxID: "",
      pincode_Email: "",
    };
  },
  watch: {    
    TaxID(newVal, oldVal) {
      if (newVal != this.pincode_TaxID) {
        this.pincode = "";
        this.pincodeCheck = false;
      }
    },
    Email(newVal, oldVal) {
      if (newVal != this.pincode_Email) {
        this.pincode = "";
        this.pincodeCheck = false;
      }
    },
  },
  beforeCreate: function () {
    if ($cookies.isKey("is_login_token")) {
      this.$router.push({
        name: "Home",
      });
    }
  },
  created: function () {
  },
  mounted: function () {
    let that = this;
    setTimeout(() => {
      that.badgeStyle = document.createElement('style');
      that.badgeStyle.innerText = '.grecaptcha-badge { display: block !important; visibility: visible !important; opacity: 1 !important; }';
      that.badgeStyle.id = 'show-recaptcha-badge';
      document.head.appendChild(that.badgeStyle);
    }, 500);
  },
  updated: function () {
  },
  methods: {
    pincode_input_onInput() {
      if (this.pincode_input != "" && this.pincode_input == this.pincode) {
        this.pincodeCheck = true;
      } else {
        this.pincodeCheck = false;
      }
    },
    async getPinCode() {
      if (this.pincodeTime > 0) {
        Swal.fire({
          title: "請稍候",
          html: "重新獲取驗證碼需等待 <span>" + this.pincodeTime + "</span> 秒",
          icon: "info",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.TaxID == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入統一編號",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (this.Email == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入Email",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (!Validate.reg_email(this.Email)) {
        Swal.fire({
          title: "錯誤",
          text: "Email格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      // 我不是機器人
      let recaptchaToken = await this.getRecaptchaToken();
      if (!recaptchaToken) {
        return;
      }
      // 顯示請稍候
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 組合並送出
      let token = AES.encrypt(this.TaxID + "|" + this.Email + "|" + recaptchaToken);
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/GetPinCode",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            var strInfo = AES.decrypt(res.PinCode).split("|");
            that.pincode = strInfo[0];
            that.pincode_TaxID = strInfo[1];
            that.pincode_Email = strInfo[2];
            // 倒數
            that.pincodeTime = 60;
            that.pincodeTitle = "重新發送(" + that.pincodeTime + ")";
            var loop = window.setInterval(function () {
              that.pincodeTime -= 1;
              that.pincodeTitle = "重新發送(" + that.pincodeTime + ")";
              if (that.pincodeTime == 0) {
                window.clearInterval(loop);
              }
            }, 1000);
            Swal.fire({
              title: "已發送驗證碼",
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        },
      });
    },
    async getRecaptchaToken() {
      try {
        await this.$recaptchaLoaded();
        return await this.$recaptcha('login');
      } catch {
        Swal.fire({
          title: "錯誤",
          text: "請確認網路環境後再試一次（RG）",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return null;
      }
    },
    async forget() {
      if (this.TaxID == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入統一編號",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (this.Email == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入Email",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (!Validate.reg_email(this.Email)) {
        Swal.fire({
          title: "錯誤",
          text: "Email格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if ((this.Password == "")) {
        Swal.fire({
          title: "錯誤",
          text: "請輸入密碼",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (this.PasswordConfirm != this.Password) {
        Swal.fire({
          title: "錯誤",
          text: "兩次輸入密碼必須相同",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      // 我不是機器人
      let recaptchaToken = await this.getRecaptchaToken();
      if (!recaptchaToken) {
        return;
      }
      // 顯示請稍候
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 組合並送出
      let token = AES.encrypt(this.TaxID + "|" + this.Password + "|" + recaptchaToken);
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/ResetPassword",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            Swal.fire({
              title: "重設密碼完成",
              text: "即將返回登入頁",
              icon: "success",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              timer: 1500,
              willClose: () => {
                that.$router.push({
                  name: "LoginForUser",
                });
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        },
      });
    },
  },
};
</script>
